module.exports = __webpack_public_path__ + "static/media/560GriffinStNW_2018-06-05_22.4d5ccd2f.jpg";